import React, { useState, useEffect } from "react";
import { Menu, X, Download } from "lucide-react";
import { nav, program } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b-4 border-campaign-ink ${
        scrolled ? "bg-campaign-yellow" : "bg-campaign-cream"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a href="#domov" className="flex items-center gap-2 group">
            <span className="font-display text-lg sm:text-2xl leading-none bg-campaign-blue text-campaign-yellow px-2 py-1 -rotate-2 group-hover:rotate-0 transition-transform">
              KURÁŇ
            </span>
            <span className="font-display text-sm sm:text-xl leading-none text-campaign-ink">
              pre Ružomberok
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="font-bold uppercase text-sm tracking-wide px-3 py-2 text-campaign-ink hover:bg-campaign-blue hover:text-campaign-cream transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={program.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download={program.pdfFileName}
              className="hidden sm:inline-flex items-center gap-2 bg-campaign-coral text-campaign-cream font-display text-sm px-4 py-2.5 border-2 border-campaign-ink shadow-brutal hover-lift uppercase"
            >
              <Download size={18} />
              Program
            </a>
            <button
              className="lg:hidden p-2 border-2 border-campaign-ink bg-campaign-blue text-campaign-cream"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-campaign-cream border-t-4 border-campaign-ink">
          <nav className="flex flex-col px-4 py-3">
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="font-bold uppercase text-base py-3 border-b border-campaign-ink/20 text-campaign-ink"
              >
                {item.label}
              </a>
            ))}
            <a
              href={program.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download={program.pdfFileName}
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 bg-campaign-coral text-campaign-cream font-display px-4 py-3 border-2 border-campaign-ink uppercase"
            >
              <Download size={18} /> Program
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
